import React from 'react';
import { Trans } from 'react-i18next';

export const SURVEY_DASHBOARD_DATA = [
  {
    id: 1,
    text: 'VIEWED',
    key: 'viewsCount',
  },
  {
    id: 2,
    text: 'TOTAL_RESPONSES',
    key: 'totalResponses',
  },
  {
    id: 3,
    text: 'COMPLETED',
    key: 'completed',
  },
  {
    id: 4,
    text: 'COMPLETION_RATE',
    key: 'completionRate',
  },
  {
    id: 5,
    text: 'DROPOUTS',
    key: 'dropout',
  },
  {
    id: 6,
    text: 'AVERAGE_TIME',
    key: 'averageTimeSeconds',
  },
];

export const DEFAULT_SMILEY_RATING = [
  'happiness-angry',
  'happiness-sad',
  'happiness-ok',
  'happiness-happy',
  'happiness-very-happy'
];

export const SURVEY_RESPONSES_BY_VALIDITY = [
  { label: <Trans>INCLUDE_INVALID_RESPONSES</Trans>, value: 'include_invalid_responses' },
  { label: <Trans>EXCLUDE_INVALID_RESPONSES</Trans>, value: 'exclude_invalid_responses' }
];
